module.exports = __webpack_public_path__ + "img/close-dark.d3438926.svg";